import { render, staticRenderFns } from "./CartExpiryModal.vue?vue&type=template&id=036aab1a&"
import script from "./CartExpiryModal.vue?vue&type=script&lang=ts&"
export * from "./CartExpiryModal.vue?vue&type=script&lang=ts&"
import style0 from "./CartExpiryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports